import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'components'

const SaveAndContinueButton = ({ saveButtonClick, disabled, loading, loadingText }) => (
  <Button
    variant="primary"
    onClick={saveButtonClick}
    disabled={disabled}
    loading={loading}
    loadingText={loadingText}
  >
    Save and continue
  </Button>
)

SaveAndContinueButton.displayName = 'SaveAndContinueButton'
SaveAndContinueButton.propTypes = {
  saveButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
}

SaveAndContinueButton.defaultProps = {
  saveButtonClick: () => {},
  disabled: false,
  loading: false,
  loadingText: undefined,
}

export default SaveAndContinueButton
